import { Flex, Spinner } from '@chakra-ui/react';
import React from 'react';

const Loading = ({ height }) => (
  <Flex alignItems="center" justifyContent="center" minH={height || '300px'}>
    <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="xl" />
  </Flex>
);
export default Loading;
